exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".avatar{display:inline-block;width:50px;height:50px;border-radius:25px;background-position:50%;background-size:cover;background-repeat:no-repeat;background-color:#000;border:1px solid #fff}.avatar.large{width:100px;height:100px;border-radius:50px}.avatar.small{width:30px;height:30px;border-radius:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/stylus-loader!./components/Navbar/avatar.styl
// module id = 464
// module chunks = 0